import httpAdmin from '@/httpCommon/axiosClient';

class RevenueService {
    getRevenueReport = async (params: any) => {
        const res = await httpAdmin.get('report/history', { params });
        return res?.data?.data;
    };
}
export default new RevenueService();
